import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { LoHangBinhChon } from './LoHangBinhChon.model';
import { BaseService } from './Base.service';
@Injectable({
    providedIn: 'root'
})
export class LoHangBinhChonService extends BaseService{

    DisplayColumns001: string[] = ['STT', 'LastUpdatedDate', 'Code', 'SortOrder', 'Description', 'HoTen', 'DienThoai', 'Email', 'DonViCongTac', 'DanhMucQuocGiaName', 'DanhMucTinhThanhName', 'IPAddress', 'KinhDo', 'ViDo' ];

    List: LoHangBinhChon[] | undefined;
    ListFilter: LoHangBinhChon[] | undefined;
    FormData!: LoHangBinhChon;

    constructor(public httpClient: HttpClient) {
        super(httpClient);
        this.Controller = "LoHangBinhChon";
    }

    GetSQLByLoHangIDToListAsync() {
        let url = this.APIURL + this.Controller + '/GetSQLByLoHangIDToListAsync';
        const formUpload: FormData = new FormData();
        formUpload.append('data', JSON.stringify(this.BaseParameter));
        return this.httpClient.post(url, formUpload, { headers: this.Headers });
    }
}

